import React from 'react';
import './Footer.css';
function Footer() {

    return (
        <div className="footer">

            <div className="footerIcons">
                <a href="https://github.com/safiyahlakhany" target="_blank">
                <div className="socialImage" id="github"></div>
                </a>

                <a href="https://www.linkedin.com/in/safiyah-lakhany/" target="_blank">
                <div className="socialImage" id="linkedin"></div>
                </a>

                <a href="mailto:safiyah@stanford.edu" target="_blank">
                <div className="socialImage" id="email" ></div>
                </a>

                <a href="https://www.instagram.com/safiyahlakhany/" target="_blank">
                <div className="socialImage" id="instagram"></div>
                </a>
            </div>
        </div>
    );
}

export default Footer;